import React, { Component, Fragment } from "react";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../utils/utils";

import Select from "../../Relatorio1/Select";

import Radio from "../../Relatorio1/Radio";
import relatorio3Service from "../../../../../services/relatorio3Service";
import TabelaFaculdade from "../../Relatorio3/Tabela/TabelaFaculdade";

export default class Tabela extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            acumulado: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes"
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado || prevState.mesSelecionado !== this.state.mesSelecionado) {
            await this.getDados();
        }
    }

    getDados = async () => {
        let { dados, acumulado } = await relatorio3Service.fetchDados(this.state.mesSelecionado);
        this.setState({ dados, acumulado });
    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value });
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value });
    }

    calculaTotal = (dados, isNotTotalGeral=true) => {

        let total = {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0,
        }

        if (dados) {
            Object.keys(dados.modalidades).map((modalidade, i) => {
                if(isNotTotalGeral) {
                    if(modalidade.indexOf("Graduaç") > -1 || modalidade.indexOf("Extensão") > -1) return;
                }
                total["matricula_regimental"]     += dados.modalidades[modalidade]["matricula_regimental"]
                total["matricula_nao_regimental"] += dados.modalidades[modalidade]["matricula_nao_regimental"]
                total["matricula_pago"]           += dados.modalidades[modalidade]["matricula_pago"]
                total["hora_regimental"]          += dados.modalidades[modalidade]["hora_regimental"]
                total["hora_nao_regimental"]      += dados.modalidades[modalidade]["hora_nao_regimental"]
                total["hora_pago"]                += dados.modalidades[modalidade]["hora_pago"]
            });
        }

        return total;

    }

    render() {

        let { dados, mesSelecionado, radioChecked, isAcumulado, acumulado } = this.state;
        let totais;

        if(isAcumulado) {
            //dados = { ...acumulado }
            dados = JSON.parse(JSON.stringify(acumulado));
        }

        return (
            <Fragment>

                <div className="card">
                    <div className="card-header">
                        Opções
                    </div>
                    <div className="card-body">
                        <Select selectMes={this.selectMes} />
                        <Radio onChange={this.onChange} radioChecked={radioChecked} />
                    </div>
                </div>

                <div>
                    <Tabs defaultActiveKey={"DR"}>

                        {dados && dados[mesSelecionado] && dados[mesSelecionado].map((valor, i) => {

                            let sigla = utils.verificaSiglaUnidade2(valor.unidade);
                            let total = this.calculaTotal(valor);
                            let totalGeral = this.calculaTotal(valor, false);

                            return (
                                <Tab eventKey={sigla} title={sigla}>

                                    <Fragment>
                                        <table border="1" className="table table-bordered table-hover table-sm table-striped">
                                            <thead>
                                                <tr>
                                                    <th colSpan="9" className="text-center">{valor.unidade}</th>
                                                </tr>
                                                <tr>
                                                    <th rowSpan="4">Modalidades</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="4" className="text-center">Matrículas</th>
                                                    <th colSpan="4" className="text-center">Horas</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="4" className="text-center">Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                    <th colSpan="4" className="text-center">Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                </tr>
                                                <tr>
                                                    {/*<th>Modalidades</th>*/}
                                                    <th>Matrículas Regimental</th>
                                                    <th>Matrículas Não-Regimental</th>
                                                    <th>Matrículas Pagas</th>
                                                    <th>Total</th>
                                                    <th>Hora Regimental</th>
                                                    <th>Hora Não-Regimental</th>
                                                    <th>Hora Pagas</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(valor.modalidades).map((modal, j) => {

                                                    // Verifica Faculdade
                                                    if((modal.indexOf("Graduaç") > -1 || modal.indexOf("Extensão") > -1)) return;

                                                    return (
                                                        <tr>
                                                            <td style={{ backgroundColor: "#c5c0ad"  }}>{modal}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad"  }}>{utils.formataNumero(valor.modalidades[modal]["matricula_pago"] + valor.modalidades[modal]["matricula_nao_regimental"] + valor.modalidades[modal]["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad"  }}>{utils.formataNumero(valor.modalidades[modal]["hora_pago"] + valor.modalidades[modal]["hora_nao_regimental"] + valor.modalidades[modal]["hora_regimental"])}</td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                                {
                                                    sigla !== "FACULDADE"
                                                    ?
                                                    <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad"  }}>
                                                        <td>Total</td>
                                                        <td>{utils.formataNumero(total["matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_pago"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_pago"] + total["matricula_nao_regimental"] + total["matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_pago"])}</td>
                                                        <td>{utils.formataNumero(total["hora_pago"] + total["hora_nao_regimental"] + total["hora_regimental"])}</td>
                                                    </tr>
                                                    :
                                                    <TabelaFaculdade {...this.state} />
                                                }
                                                {
                                                    sigla === "DR"
                                                    ?
                                                    <Fragment>
                                                        <TabelaFaculdade {...this.state} />
                                                        <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad" }}>
                                                            <td>Total Geral</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_pago"] + totalGeral["matricula_nao_regimental"] + totalGeral["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_pago"] + totalGeral["hora_nao_regimental"] + totalGeral["hora_regimental"])}</td>
                                                        </tr>
                                                    </Fragment>
                                                    :
                                                    null
                                                }
                                            </tbody>
                                        </table>
                                    </Fragment>

                                </Tab>
                            )
                        })}

                    </Tabs>
                </div>

            </Fragment>
        )
    }
}